module.exports = __webpack_public_path__ + "583d46885330f9689ef73462d82f5a2e.svg";